var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 12.6667C6.6665 13.4 7.2665 14 7.99984 14C8.73317 14 9.33317 13.4 9.33317 12.6667C9.33317 11.9333 8.73317 11.3333 7.99984 11.3333C7.2665 11.3333 6.6665 11.9333 6.6665 12.6667Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 3.33329C6.6665 4.06663 7.2665 4.66663 7.99984 4.66663C8.73317 4.66663 9.33317 4.06663 9.33317 3.33329C9.33317 2.59996 8.73317 1.99996 7.99984 1.99996C7.2665 1.99996 6.6665 2.59996 6.6665 3.33329Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.00004C6.6665 8.73337 7.2665 9.33337 7.99984 9.33337C8.73317 9.33337 9.33317 8.73337 9.33317 8.00004C9.33317 7.26671 8.73317 6.66671 7.99984 6.66671C7.2665 6.66671 6.6665 7.26671 6.6665 8.00004Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.80d5f0d9c8cf88b22a7be46901c592f5.svg";
export { ForwardRef as ReactComponent };